import { useQuery } from "@tanstack/react-query";
import type { SolveDetail } from "@playbookai/types";
import { retryTransientRead } from "@playbookai/api-clients";
import { useApiClient } from "../api/context.js";
import { solvesApi } from "../api/playbook-be-client.js";
import {
  solveDetailQueryKey,
  useSolveAuthScope,
} from "../access/auth-scope.js";

/**
 * Single-Solve detail read. Returns `SolveDetail` — the base `Solve` fields
 * (incl. `canvasLocked`) plus the capability snapshot (`myRole`/
 * `isFacilitator`/`lockedPhases`) the lock/role affordances feed into the
 * shared `authorize()` (ADR-0019).
 */
export function useSolve(solveId: string | undefined, enabled = true) {
  const config = useApiClient();
  const scope = useSolveAuthScope(solveId);
  return useQuery<SolveDetail>({
    queryKey:
      scope && solveId
        ? solveDetailQueryKey(scope, solveId)
        : ["resource-access", "missing", "solve", solveId ?? "", "detail"],
    queryFn: ({ signal }) => solvesApi.get(config, solveId!, signal),
    enabled: Boolean(enabled && scope && solveId),
    retry: retryTransientRead,
    staleTime: 30_000,
  });
}
